<template>
    <nav :class="['navbar navbar-expand-md navbar-light', { 'is-sticky': isSticky }]">

        <router-link class="navbar-brand" to="/">
            <img src="../../assets/img/jill_icon_n.png" alt="Logo">
        </router-link>

        <div class="navbar-toggler" @click="toggleMenu" :aria-pressed="active ? 'true' : 'false'"
            :class="{ 'active': button_active_state }">
            <i class='bx bx-menu'></i>
            <i class='bx bx-x'></i>
        </div>

        <div class="collapse navbar-collapse" :class="{ toggler: active }">
            <ul class="navbar-nav">

                <li class="nav-item">
                    <a class="nav-link" @click="scroll('home')" href="javascript:void(0)">
                        {{ $t('nav.home') }}
                    </a>
                </li>

                <li class="nav-item">
                    <a class="nav-link" @click="scroll('service')" href="javascript:void(0)">
                        {{ $t('nav.services') }}
                    </a>
                </li>

                <li class="nav-item">
                    <a class="nav-link" @click="scroll('service-multiple')" href="javascript:void(0)">
                        {{ $t('nav.web') }}
                    </a>
                </li>

                <li class="nav-item">
                    <a class="nav-link" @click="scroll('maintenance')" href="javascript:void(0)">
                        {{ $t('nav.ads') }}
                    </a>
                </li>

                <li class="nav-item">
                    <a class="nav-link" @click="scroll('contact-strip')" href="javascript:void(0)">
                        {{ $t('nav.contact') }}
                    </a>
                </li>
                <li class="nav-item">
                    <router-link class="nav-link" to="/premium">
                        {{ $t('nav.premium') }}
                    </router-link>
                </li>

                <li class="nav-item">
                    <a class="nav-link" @click="scroll('aboutus')" href="javascript:void(0)">
                        {{ $t('nav.about') }}
                    </a>
                </li>

                <!-- BANDERAS -->
                <li class="nav-item lang-flags">
                    <img src="https://flagcdn.com/w40/es.png" alt="Español" @click="changeLang('es')"
                        :class="{ active: $i18n.locale === 'es' }" />
                    <img src="https://flagcdn.com/w40/gb.png" alt="English" @click="changeLang('en')"
                        :class="{ active: $i18n.locale === 'en' }" />
                </li>

            </ul>
        </div>

    </nav>
</template>

<script>
export default {
    name: 'NavbarOne',
    data() {
        return {
            isSticky: false,
            active: false,
            button_active_state: false
        }
    },
    mounted() {
        window.addEventListener('scroll', () => {
            this.isSticky = window.scrollY >= 100
        })
    },
    methods: {
        scroll(refName) {
        if (this.$route.path !== '/') {
            this.$router.push({ path: '/', hash: `#${refName}` })
        } else {
            const element = document.getElementById(refName)
            if (element) {
                element.scrollIntoView({ behavior: "smooth" })
            }
        }
    },
        changeLang(lang) {
            this.$i18n.locale = lang
            localStorage.setItem('lang', lang)
        },
        toggleMenu() {
            this.active = !this.active
            this.button_active_state = !this.button_active_state
        }
    }
}
</script>

<style scoped>
/* ===============================
   BANDERAS IDIOMA
   =============================== */

.lang-flags {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: 15px;
}

.navbar-toggler {
    color: #e8e7e7 !important;
    border: none;
}

.lang-flags img {
    width: 26px;
    height: 18px;
    cursor: pointer;
    border-radius: 3px;
    transition: all 0.2s ease;
    opacity: 0.6;
}

/* Hover */
.lang-flags img:hover {
    transform: scale(1.1);
    opacity: 1;
}

/* Activo */
.lang-flags img.active {
    opacity: 1;
    box-shadow: 0 0 0 2px #ff8a00;
}
</style>